import { render, staticRenderFns } from "./ImportPatient.vue?vue&type=template&id=0564454e&"
import script from "./ImportPatient.vue?vue&type=script&lang=js&"
export * from "./ImportPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports